import React from 'react';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, GridLegacy as Grid, Stack } from '@mui/material';

import { MappedAuditLog } from '~/services/AuditService';
import { formatDateShort } from '~/services/TimeService';

import { daysOfWeekMessage } from '~/utils/daysOfWeek';

import { AuditLog } from './AuditLog';

type Props = {
  blackoutDateBlocks: Array<MappedAuditLog>;
};

export default function BlackoutDateBlockHistory({ blackoutDateBlocks }: Props) {
  const firstLog = blackoutDateBlocks[0];
  const addedData = firstLog.diff?.added as { start_date?: string; end_date?: string } | undefined;

  return (
    <Accordion disableGutters sx={{ paddingLeft: '2em' }}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Grid container item spacing={1}>
          <Grid item>
            {formatDateShort(addedData?.start_date)} &nbsp; &mdash; &nbsp;
            {formatDateShort(addedData?.end_date)}
          </Grid>
          <Grid item>{daysOfWeekMessage(addedData)}</Grid>
        </Grid>
      </AccordionSummary>
      <AccordionDetails>
        <Stack spacing={1}>
          {blackoutDateBlocks.map((block) => (
            <AuditLog key={block.logId} auditLog={block} />
          ))}
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
}
